import { UserPermissionSettingVM } from '@/view-model/user-management/UserPermissionSettingVM';
import { objDeepCopy } from '@/utils/object';
import { getInitialState } from './state';
export const mutationType = {
    /** 다이얼로그 열기/닫기 */
    SET_DIALOG_DETAIL: 'SET_DIALOG_DETAIL',
    /** 사용자 권한 조회 */
    GET_USER_PERMISSION_LIST: 'GET_USER_PERMISSION_LIST',
    /** 사용자 권한 목록 붙여넣기 */
    PASTE_USER_PERMISSION_LIST: 'PASTE_USER_PERMISSION_LIST',
    /** 사용자 권한 업데이트 */
    UPDATE_USER_PERMISSION: 'UPDATE_USER_PERMISSIO',
    /** 사용자 권한 목록 일괄 업데이트 (상위권한 변경 시) */
    UPDATE_USER_PERMISSION_LIST: 'UPDATE_USER_PERMISSION_LIST',
    /** 사용자 권한 목록 초기화 */
    RESET_USER_PERMISSION_LIST: 'RESET_USER_PERMISSION_LIST',
    /** 전체 초기화 */
    RESET_STORE: 'RESET_STORE',
};
const mutations = {
    [mutationType.SET_DIALOG_DETAIL](state, payload) {
        state.dialogDetail.userInfo = payload;
    },
    [mutationType.GET_USER_PERMISSION_LIST](state, data) {
        state.originData = data.map((item) => new UserPermissionSettingVM(objDeepCopy(item._raw)));
        state.userPermissionList = data;
    },
    /** 상위권한 일괄수정 */
    [mutationType.UPDATE_USER_PERMISSION_LIST](state, payload) {
        // 상위 - 하위권한 룰 적용 (상위 권한 수정 시 하위 권한은 함께 변경된다.)
        state.userPermissionList.forEach((item, index) => {
            if (item.parentCode !== payload.parentCode) {
                return;
            }
            state.userPermissionList[index].isAuthorized = payload.isAuthorized;
        });
    },
    /** 권한 붙여넣기 */
    [mutationType.PASTE_USER_PERMISSION_LIST](state, payload) {
        state.userPermissionList.forEach((_, index) => {
            state.userPermissionList[index].isAuthorized = payload[index].isAuthorized;
        });
    },
    /** 하위권한 수정 */
    [mutationType.UPDATE_USER_PERMISSION](state, payload) {
        // 권한을 찾아 수정한다.
        const index = state.userPermissionList.findIndex((item) => item.code === payload.code);
        if (index === -1) {
            return;
        }
        state.userPermissionList[index].isAuthorized = payload.isAuthorized;
        // 상위 - 하위권한 룰 적용 (하위가 하나라도 true면 상위는 true, 하위가 모두 false면 상위는 false)
        const filteredList = state.userPermissionList
            .filter((item) => (item.parentCode === payload.parentCode)
            && !item.isDepth2);
        const hasTrue = filteredList.some((child) => child.isAuthorized === true);
        const parentIntdex = state.userPermissionList
            .findIndex((item) => item.code === payload.parentCode);
        if (parentIntdex === -1) {
            return;
        }
        state.userPermissionList[parentIntdex].isAuthorized = hasTrue;
    },
    [mutationType.RESET_USER_PERMISSION_LIST](state) {
        state.userPermissionList = [];
    },
    [mutationType.RESET_STORE](state) {
        Object.assign(state, getInitialState());
    },
};
export default mutations;
